import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
import { CaptionLazy } from "../../_shared/figure/caption-renderer-lazy.js";
const Giphy = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_giphy_lazy" */
    "./viewer-giphy.js"
  )
);
const GiphyRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    Giphy,
    {
      key: node.id,
      node,
      nodeIndex,
      NodeViewContainer,
      ...props
    }
  );
};
const GiphyLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(GiphyRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.GIF]: GiphyLazy,
  [Node_Type.CAPTION]: CaptionLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
